import * as React from 'react';
import { Box } from '@material-ui/core';
import ErrorCard from 'components/@common/ErrorCard';

type State = {
  error: any;
};

type Props = {
  children: any;
  fallbackComponent?: any;
};

class ErrorBoundary extends React.Component<Props, State> {
  state = { error: null };

  componentDidCatch = (error: any, errorInfo: any): void => {
    this.setState({ error });
    console.error({ error });
    console.error({ errorInfo });
  };

  render(): JSX.Element {
    const { error } = this.state;
    const { fallbackComponent: FallbackComponent = null, children } = this.props;

    if (error) {
      if (this.props.fallbackComponent) {
        return <FallbackComponent />;
      }

      return (
        <Box display="flex" justifyContent="center" alignItems="center" p={4}>
          <ErrorCard />
        </Box>
      );
    }

    return children;
  }
}

export default ErrorBoundary;
